// extracted by mini-css-extract-plugin
export default {"categoryHeaderName":"_4ngugj","categoryHeaderDescription":"_nh3uxg"};